import { styled } from 'styled-components';
import {
  heading1,
  textTinyNormal,
  textTinySemiBold,
  textSmallSemiBold,
  textTinyBold
} from '../../../Typography';

export const Container = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: var(--space-150);
  justify-content: end;
  cursor: pointer;
  // probably should not be a button radius
  border-radius: var(--border-radius-button);
  text-decoration: none;

  z-index: 0;
  // css shenaningans for the bottom border gradiant
   > * {
     position: relative;
     z-index: 1;
   }

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--black-300);
    border-radius: var(--border-radius-button);
    z-index: -2;
    transition: background-color 0.2s ease-out;
  }

  &:hover:before {
    background: var(--black-400);
  }

  &:after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #0FFEE6, #7654FC);
    border-radius: var(--border-radius-button);
    z-index: -3;
  }

  .cardHeader {
    display: flex;
    align-items: center;
    ${textSmallSemiBold};
    color: var(--text-standard-secondary);

    svg {
      margin-left: auto;
    }
  }

  .mainFigure {
    margin-top: var(--space-300);
    margin-bottom: var(--space-50);
    color: var(--text-success);;
    ${heading1};

    .verb {
      ${textTinySemiBold}
    }
  }

  .secondaryFigure {
    margin: 0;
    color: var(--text-standard-primary);
    ${textTinyBold};
    .verb {
      ${textTinyNormal};
    }
  }
`;
